import { commentsItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          读者心声
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>
              <p className="text-xs text-foreground-500">
                正在追：<span className="text-primary-600 font-medium">{item.work}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}